import { render, staticRenderFns } from "./TypeNotInspectedForm.vue?vue&type=template&id=216d4fff&"
import script from "./TypeNotInspectedForm.vue?vue&type=script&lang=js&"
export * from "./TypeNotInspectedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports